// extracted by mini-css-extract-plugin
export default {"button":"oBb97RTRfWjAd6KcvGGR","content":"SEL5nMxohgKDzv1P5v9C"};